/**
 * Created by AlexanderC on 6/22/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ObjectValidationFailedException = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when object validation fails on a joi schema/model
 */
let ObjectValidationFailedException = exports.ObjectValidationFailedException = function (_Exception) {
  _inherits(ObjectValidationFailedException, _Exception);

  /**
   * @param {String} schemaName
   * @param {String} error
   */
  function ObjectValidationFailedException(schemaName, error) {
    _classCallCheck(this, ObjectValidationFailedException);

    var _this = _possibleConstructorReturn(this, (ObjectValidationFailedException.__proto__ || Object.getPrototypeOf(ObjectValidationFailedException)).call(this, `Object validation failed on schema ${schemaName}: ${error}`));

    _this._originalError = error;
    return _this;
  }

  /**
   * @returns {Error}
   */


  _createClass(ObjectValidationFailedException, [{
    key: 'originalError',
    get: function get() {
      return this._originalError;
    }
  }]);

  return ObjectValidationFailedException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-validation/lib.compiled/Exception/ObjectValidationFailedException.js
// module id = 458
// module chunks = 0